var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lp-toolbar-textarea-font-family"},[_c('v-overflow-btn',{attrs:{"items":_vm.blockGlobals.fontFamilies,"label":"Font Family","value":_vm.editorFontFamily},on:{"change":function($event){_vm.editor.chain().focus().setFontFamily($event).run()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }